import React from 'react'

// STYLED COMPONENTS
import { Item, Container, Icon, Label, ContainerSubMenus, Badge } from "./styles";

export default function HeaderItem({
    children,

    dropdownMenuPosition = 'left',

    badge = '',
    icon = '',
    title = '',
    color = '#fff',
    onClick = () => { }
}) {
    return (
        <Item
            className={`nav-item-n0`}
            tabIndex="-1"
            onClick={(e) => {
                e.target.focus();
                onClick();
            }}

            hasSubMenu={children ? true : false}
        >
            {badge && (
                <Badge>
                    {badge}
                </Badge>
            )}
            <Container>
                <Icon color={color} className={icon} />
                <Label color={color}>{title}</Label>
            </Container>

            {children && (
                <ContainerSubMenus className="nav-item-container-sub" dropdownMenuPosition={dropdownMenuPosition}>
                    {children}
                </ContainerSubMenus >
            )
            }
        </Item >
    )
}
